import React, { Component } from "react";
import config from "lib/fr-config";
import ItemCategory from "lib/itemCategory";
import { getDeviceType } from "lib/deviceInfo";
import CommonModalView from "presentational/common/modals/CommonModalView";
import CommonListItemButtonView from "presentational/common/CommonListItemButtonView";
import CommonIconView from "presentational/common/CommonIconView";
import TextButtonView from "presentational/common/TextButtonView";
import TXT from "presentational/common/multinational/TXT";
import List from "@material-ui/core/List";
import PropTypes from "prop-types";

const FONT_SIZE_OF_BREADCRUMB = 12;

const transitionTime = config.css.animation.modalDurationMilliSec;

const colorCss = config.css.color;

const css = {
  breadcrumbWrapper: {
    paddingBottom: 20,
    display: "flex",
    alignItems: "flex-end",
    flexWrap: "wrap",
    position: "sticky",
    zIndex: 100,
    backgroundColor: colorCss.colorOfBackground,
    top: 0,
    left: 0,
    right: 0
  },
  rootBreadcrumbBtnWrapper: { flexShrink: 0 },
  breadcrumbUnit: { display: "flex", alignItems: "center" },
  breadcrumbIcon: {
    color: colorCss.colorOfPrimary,
    fontSize: FONT_SIZE_OF_BREADCRUMB
  },
  childrenText: {
    wordBreak: "keep-all"
  }
};

class CategorySelectorModalView extends Component {
  static propTypes = {
    value: PropTypes.string,
    leafCategoryMode: PropTypes.bool,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired
  };

  state = {
    valueOfPropsForSync: null,
    displayedValue: null,
    childrenCategoryList: [],
    categoryParentStepList: []
  };

  getCssOfModalPaper() {
    const deviceType = getDeviceType();
    return {
      width: "100%",
      height: deviceType === "desktop" ? "65vh" : undefined,
      marginLeft: 0,
      marginRight: 0
    };
  }

  syncDataFromProps() {
    const { value } = this.props;
    const { valueOfPropsForSync } = this.state;

    if (value === valueOfPropsForSync) return null;

    this.setState({ valueOfPropsForSync: value });
    this.changeDisplayedValue(value);
  }

  closeModalWithOption(type, value) {
    const { onSelect, onClose } = this.props;
    onClose();
    switch (type) {
      case "saveAndSubmit":
        setTimeout(() => {
          onSelect(value);
          this.changeDisplayedValue(value);
        }, transitionTime);
        return null;
      case "onlySave":
        setTimeout(() => {
          this.changeDisplayedValue(value);
        }, transitionTime);
        return null;
      case "onlyClose":
      default:
        return null;
    }
  }

  getChildrenTextElem(value) {
    const list = ItemCategory.getChildrenList(value);
    if (!list || list.length === 0) return null;
    return (
      <span>
        {list.map((val, idx) => (
          <span key={idx} style={css.childrenText}>
            {idx !== 0 && ", "}
            <TXT
              textType="category"
              categoryType="nameForCatModal"
              name={val}
            />
          </span>
        ))}
      </span>
    );
  }

  getBreadcrumbListElem() {
    const { categoryParentStepList } = this.state;
    return (
      <div style={css.breadcrumbWrapper}>
        <span style={css.rootBreadcrumbBtnWrapper}>
          <TextButtonView
            paddingSize={"small"}
            fontSize={FONT_SIZE_OF_BREADCRUMB}
            onClick={this.handleBreadcrumbBtnClick(undefined)}
          >
            <TXT
              textType="category"
              categoryType="nameForCatModal"
              name="all"
            />
          </TextButtonView>
        </span>
        {categoryParentStepList.map(value => (
          <span key={value} style={css.breadcrumbUnit}>
            <CommonIconView type={"breadcrumb"} style={css.breadcrumbIcon} />
            <TextButtonView
              paddingSize={"small"}
              fontSize={FONT_SIZE_OF_BREADCRUMB}
              onClick={this.handleBreadcrumbBtnClick(value)}
            >
              <TXT
                textType="category"
                categoryType="nameForCatModal"
                name={value}
              />
            </TextButtonView>
          </span>
        ))}
      </div>
    );
  }

  getBackBtnElem() {
    const { displayedValue } = this.state;
    if (!displayedValue || displayedValue === "root") return null;
    return (
      <CommonListItemButtonView
        onClick={this.handleBackBtnClick}
        primary={<CommonIconView type={"back"} />}
      />
    );
  }

  getWholeCategoryBtnElem() {
    const { leafCategoryMode } = this.props;
    const { displayedValue } = this.state;
    if (leafCategoryMode) return null;
    if (!displayedValue || displayedValue === "root") return null;
    const childrenListTextElem = this.getChildrenTextElem(displayedValue);
    if (!childrenListTextElem) return null;
    return (
      <CommonListItemButtonView
        onClick={this.handleCategorySelectBtnClick(displayedValue)}
        primary={
          <TXT
            textType="category"
            categoryType="groupName"
            name={displayedValue}
          />
        }
      />
    );
  }

  getCategoryListBtnElem() {
    const { childrenCategoryList } = this.state;

    if (!childrenCategoryList || childrenCategoryList.length === 0) return null;

    return childrenCategoryList.map(value => {
      const childrenListTextElem = this.getChildrenTextElem(value);

      return (
        <CommonListItemButtonView
          key={value}
          onClick={
            childrenListTextElem
              ? this.handleParentCategoryBtnClick(value)
              : this.handleCategorySelectBtnClick(value)
          }
          primary={
            <div>
              <TXT
                textType="category"
                categoryType="nameForCatModal"
                name={value}
              />
            </div>
          }
          secondary={childrenListTextElem}
        />
      );
    });
  }

  getContentElem() {
    return (
      <div>
        {this.getBreadcrumbListElem()}
        <List disablePadding>
          {this.getBackBtnElem()}
          {this.getWholeCategoryBtnElem()}
          {this.getCategoryListBtnElem()}
        </List>
      </div>
    );
  }

  changeDisplayedValue(name) {
    let category, childrenCategoryList, categoryParentStepList;
    category = name || "root";

    const childrenList = ItemCategory.getChildrenList(category);
    const parentStepList = ItemCategory.getParentStepList(category);
    if (childrenList.length === 0) {
      const index = parentStepList.length - 2;
      category = index >= 0 ? parentStepList[index] : "root";
      childrenCategoryList = ItemCategory.getChildrenList(category);
      categoryParentStepList = ItemCategory.getParentStepList(category);
    } else {
      childrenCategoryList = childrenList;
      categoryParentStepList = parentStepList;
    }

    this.setState({
      displayedValue: category,
      childrenCategoryList,
      categoryParentStepList
    });
  }

  handleBackBtnClick = () => {
    const { categoryParentStepList } = this.state;
    const { length } = categoryParentStepList;
    const indexOfParent = length - 2;
    if (indexOfParent < 0) {
      this.changeDisplayedValue("root");
    } else {
      this.changeDisplayedValue(categoryParentStepList[indexOfParent]);
    }
  };

  handleCategorySelectBtnClick = value => () => {
    this.closeModalWithOption("saveAndSubmit", value);
  };

  handleParentCategoryBtnClick = value => () => {
    const childrenList = ItemCategory.getChildrenList(value);
    if (!childrenList || childrenList.length === 0) return null;
    this.changeDisplayedValue(value);
  };

  handleBreadcrumbBtnClick = value => () => {
    this.changeDisplayedValue(value);
  };

  handleCancelBtnClick = () => {
    const { value } = this.props;
    this.closeModalWithOption("onlySave", value);
  };

  render() {
    const { open } = this.props;

    return (
      <CommonModalView
        open={open}
        // fullScreen={getDeviceType() === "mobile"}
        onClose={this.handleCancelBtnClick}
        paperStyle={this.getCssOfModalPaper()}
        titleText={<TXT name="titleModal_category" />}
        contentComponent={this.getContentElem()}
        firstButtonText={<TXT name="btnModal_close" />}
        firstButtonFunc={this.handleCancelBtnClick}
      />
    );
  }

  componentDidMount() {
    this.syncDataFromProps();
  }

  componentDidUpdate() {
    this.syncDataFromProps();
  }
}

export default CategorySelectorModalView;
